<template>
    <!-- 盲盒 -->
    <div class="blind-box"
        :style="{background: bgColor}">
        <div class="clear-fix lottery-wrapper"
            :style="{'background-image': `url(${bannerPic})`,'height': isBlindBoxQuantityNine ? '738px' : '676px'}">
            <!-- 获奖名单轮播--上方 -->
            <winner-list v-if="winnerScrollBarShow"
                :winnerList="winnerList"
                :activityObj="activityObj"></winner-list>
            <div class="banner awardRotateDisc"
                :style="turnplateStyle">
                <!-- 盲盒抽奖区域 -->
                <div class="blindBox-main">
                    <!-- 抽奖引导图 -->
                    <img v-if="(activityStatus == '0' || activityStatus == '1') && participateTimes && guideLotteryUrl && !whetherActivity"
                        class="guideLotteryUrl"
                        :src="guideLotteryUrl"
                        alt="" />
                    <img v-if="(activityStatus == '0' || activityStatus == '1') && participateTimes && !guideLotteryUrl && !whetherActivity"
                        class="guideLotteryUrl"
                        src="static/runtime/images/magic/award/guideLottery.png"
                        alt="" />
                    <!-- 定时开奖样式 -->
                    <div v-if="regularDrawShowStatus && ['1','2','3','6'].includes(regularDrawShowStatus)"
                        class="before-award-mask"
                        :class="{'before-award-mask-nine': isBlindBoxQuantityNine}">
                        <div v-if="regularDrawShowStatus == '1'"
                            class="award-mask-center">
                            <div>
                                恭喜您已中奖
                            </div>
                        </div>
                        <div v-if="regularDrawShowStatus == '2'"
                            class="award-mask-center">很遗憾未中奖</div>
                        <div v-if="regularDrawShowStatus == '3'"
                            class="award-mask-center">活动已结束</div>
                        <div v-if="regularDrawShowStatus == '6'"
                            class="award-mask-center">
                            <p style="margin: 30px 0px -25px 0;">开奖中···</p>
                            <p style="margin-top: 20px;">请耐心等待 </p>
                        </div>
                    </div>
                    <!-- 盲盒抽奖(蒙层) （定时抽奖只有初始化可抽奖）活动进行中，用户无次数 -->
                    <!-- regularDrawShowStatus： 1.活动结束后,用户有中奖;2.活动结束后,用户未中奖;3.活动已结束,但是用户未参与过活动; -->
                    <!-- 4.活动进行中,用户无次数;5.活动进行中,用户有次数;6.活动已结束,但是活动中奖逻辑还在计算中(开奖中) -->
                    <div v-if="regularDrawShowStatus && regularDrawShowStatus == '4' && drawWheelType == '3' && participateType == '1'"
                        class="before-award-mask"
                        :class="{'before-award-mask-nine': isBlindBoxQuantityNine}">
                        <div class="award-mask-center">
                            <p>待开奖</p>
                            <p class="font-24">{{ '已超过' + userNum + '位参加' }} </p>
                            <div v-for="(item,index) in headerList"
                                :key="index"
                                style="display: inline;">
                                <img v-if="item"
                                    :src="item"
                                    style="width: 16%; height: 16%; margin-right: 2px;" />
                                <img v-else
                                    src="static/runtime/images/magic/award/userImg.png"
                                    style="width: 16%; height: 16%; margin-right: 2px;"
                                    alt="" />
                            </div>
                            <p v-if="userNum > 5"
                                style="display: inline;">...</p>
                        </div>
                    </div>
                    <!-- 盲盒抽奖(蒙层) （定时抽奖 除只配置 初始化可抽奖 的其他可能 抽奖按钮都展示 --刘赟/侯宁）活动进行中 -->
                    <!-- hasMask：是否参与过活动 -->
                    <!-- drawWheelType: 大转盘抽奖类型，1：普通抽奖；2：整点购抽奖；3：定时开奖 -->
                    <!-- participateType: 抽奖类型(1 初始化抽奖，2 积分抽奖 3 全部  4 订单抽奖 5 每日抽奖 6 分享抽奖) -->
                    <div v-if="hasMask && drawWheelType == '3' && participateType != '1'"
                        class="before-award-mask"
                        :class="{'before-award-mask-nine': isBlindBoxQuantityNine}">
                        <div class="award-mask-center">
                            <p v-if="winningRate > 0">中奖率+{{ winningRate }}</p>
                            <p class="font-20">待开奖</p>
                            <p class="font-20">{{ '已超过' + userNum + '位参加' }} </p>
                            <div v-for="(item,index) in headerList"
                                :key="index"
                                style="display: inline;">
                                <img v-if="item"
                                    :src="item"
                                    style="width: 16%; height: 16%; margin-right: 2px;" />
                                <img v-else
                                    src="static/runtime/images/magic/award/userImg.png"
                                    style="width: 16%; height: 16%; margin-right: 2px;"
                                    alt="" />
                            </div>
                            <p v-if="userNum > 5"
                                style="display: inline;">...</p>
                            <div><Button class="lottery-btn"
                                    @click="goLottery()"><span>抽奖</span></Button></div>
                        </div>
                    </div>
                    <!-- 背景 -->
                    <img v-if="drawWheelUrl"
                        :src="drawWheelUrl"
                        alt=""
                        style="width: 100%;" />
                    <!-- 盲盒礼物放置区域，点击礼物进行抽奖 -->
                    <div v-if="drawPointUrl"
                        class="blindBox-box"
                        :class="{ 'blindBox-box-nine': isBlindBoxQuantityNine }">
                        <img v-for="item in Number(activityObj.activityConfig.blindBoxQuantity || 6)"
                            :key="item"
                            :src="drawPointUrl"
                            :class="{'blindBox-anima': boxIndex == item}"
                            @click="pointer(item)" />
                    </div>
                    <!-- 没有次数时覆盖盒子 -->
                    <div v-if="!pointDrawFlag && activityStatus == 1 && (drawType == 'initDraw' || drawType == 'orderDraw' || !drawType) && !canDrawFlag"
                        class="blindBox-mask"
                        :class="{ 'blindBox-box-nine': isBlindBoxQuantityNine }"
                        @click="noChanceFirst()">
                    </div>
                    <!-- 积分抽奖没有积分时覆盖盒子 -->
                    <div v-if="activityStatus == 1 && drawType == 'pointDraw' && !canDrawFlag"
                        class="blindBox-mask"
                        :class="{ 'blindBox-box-nine': isBlindBoxQuantityNine }"
                        @click="noPoints">
                    </div>
                    <!-- 活动未开始时覆盖盲盒 -->
                    <div v-if="activityStatus == 0"
                        class="blindBox-mask"
                        :class="{ 'blindBox-box-nine': isBlindBoxQuantityNine }"
                        @click="notStart"></div>
                    <!-- 活动已结束覆盖盲盒 -->
                    <div v-if="activityStatus == 3"
                        class="blindBox-mask"
                        :class="{ 'blindBox-box-nine': isBlindBoxQuantityNine }"
                        @click="hasEnd"></div>
                    <!-- 活动已暂停覆盖盲盒 -->
                    <div v-if="activityStatus == 2"
                        class="blindBox-mask"
                        :class="{ 'blindBox-box-nine': isBlindBoxQuantityNine }"
                        @click="hasStop"></div>
                </div>
                <!-- 盲盒显示剩余次数 -->
                <div class="content-display-area">
                    <!-- 活动未进行 -->
                    <div v-if="!isRunning"
                        class="blindBox-chance">{{ pointerText }}</div>

                    <!-- 普通抽奖抽奖文案展示 -->
                    <div v-else-if="isShowOrdinaryDrawText"
                        class="blindBox-chance">
                        <div v-if="drawType == 'initDraw' || drawType == 'orderDraw'">
                            <div v-if="tips">{{ tips }}</div>
                            <div v-else> 剩余抽奖次数：{{ participateTimes > 99 ? '99+' : participateTimes }}次</div>
                        </div>
                        <div v-if="isPointDraw">{{ pointDrawText }}</div>
                    </div>

                    <!-- 整点购抽奖文案展示 -->
                    <div v-else-if="isShowShopOnHourDrawText"
                        class="blindBox-chance">
                        <div v-if="drawType == 'initDraw' || drawType == 'orderDraw'">
                            <div v-if="tips">{{ tips }}</div>
                            <div v-else> 剩余抽奖次数：{{ participateTimes > 99 ? '99+' : participateTimes }}次</div>
                        </div>
                        <div v-if="isPointDraw">{{ `每次抽奖扣除${ drawPointConsumption + poinsOrDiamonds }` }}</div>
                    </div>

                    <!-- 定时抽奖抽奖文案展示 -->
                    <div v-else-if="isShowTimedDrawText"
                        class="blindBox-chance">
                        <div v-if="(drawType == 'initDraw' || drawType == 'orderDraw') && ['4','5'].includes(regularDrawShowStatus)">
                            <div v-if="tips">{{ tips }}</div>
                            <div v-else> 剩余抽奖次数：{{ participateTimes > 99 ? '99+' : participateTimes }}次</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- 我的奖品，中奖名单 -->
        <reward-query :tigerLottery="false"
            :miniprogramFlag="miniprogramFlag"
            :activityObj="activityObj"
            :loginType="loginType"
            @goWinnerList="goWinnerList"
            @goHiHonorMiniProgram="goHiHonorMiniProgram"></reward-query>
        <!-- 奖品池 -->
        <prize-pool :sectionThreeColor="sectionThreeColor"
            :tigerLottery="false"
            :awardNum="awardNum"
            :bigWheelRewardList="bigWheelRewardList"
            :classOption="classOption"></prize-pool>
        <!-- 会员信息和中奖记录（共用） -->
        <member-and-winning :memberInfo="memberInfo"
            :bigWheelActivityType="bigWheelActivityType"
            :tigerLottery="false"
            :sectionThreeColor="sectionThreeColor"
            :myRecords="myRecords"
            :pointsValue="pointsValue"
            @viewRecord="viewRecord"
            @nextStep="nextStep"></member-and-winning>
        <!-- 活动规则 -->
        <activity-rules :bigWheelRewardList="bigWheelRewardList"
            :bigWheelActivityType="bigWheelActivityType"
            :tigerLottery="false"
            :sectionThreeColor="sectionThreeColor"
            :ruleDesci="ruleDesci"></activity-rules>
    </div>
</template>
<script>
import memberAndWinning from '../../components/member-and-winning.vue';
import rewardQuery from '../../components/reward-query.vue';
import activityRules from '../../components/activity-rules.vue';
import winnerList from '../../components/winner-list.vue';
import prizePool from '../../components/prize-pool.vue';
import mixins from '../../mixin';
import { BigWheelConstants as BWC } from '../../common/global-variable';

export default {
  components: {
    memberAndWinning,
    rewardQuery,
    activityRules,
    winnerList,
    prizePool,
  },
  mixins: [mixins],
  props: {
    activityStatus: String,
    participateTimes: Number,
    guideLotteryUrl: String,
    whetherActivity: Boolean,
    regularDrawShowStatus: String,
    drawWheelType: String,
    participateType: String,
    userNum: Number,
    headerList: Array,
    hasMask: Boolean,
    winningRate: Number,
    drawWheelUrl: String,
    drawPointUrl: String,
    pointDrawFlag: Boolean,
    miniprogramFlag: Boolean,
    loginType: String,
    activityUrl: String,
    drawType: String,
    canDrawFlag: Boolean,
    bannerPic: String,
    boxIndex: String,
    activityObj: Object,
    winnerList: Array,
    tigerLottery: Boolean,
    ruleDesci: String,
    sectionThreeColor: String,
    bigWheelRewardList: Array,
    pointsValue: String,
    memberInfo: Object,
    myRecord: Array,
    bgColor: String,
    awardNum: Number,
    classOption: Object,
    userBase: Object,
    myRecords: Array,
    tips: String,
    drawPointConsumption: Number,
    poinsOrDiamonds: String,
    isLoginFlag: Boolean,
    // 用户的抽奖状态
    drawStatus: {
      type: String,
      default: '',
    },
    // 页面展示文案
    pageDisplayContent: {
      type: String,
      default: '',
    },
    // 弹窗提示语
    tipsMessage: {
      type: String,
      default: '',
    },
    // 弹框提示语对应code
    tipsMessageCode: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      BWC: BWC,
      bigWheelActivityType: BWC.BigWheelActivityType.blindBox,
    };
  },
  computed: {
    // 中奖信息滚动栏是否显示
    winnerScrollBarShow() {
      return this.activityObj.prizeWinningScrollFlag == BWC.prizeWinningScrollFlag.display && this.winnerList.length > 0;
    },
    turnplateStyle() {
      return {
        'padding-top': this.winnerScrollBarShow ? '202px' : '260px',
        background: this.tigerBgColor,
      };
    },
    isBlindBoxQuantityNine() {
      return Number(this.activityObj.activityConfig.blindBoxQuantity) === 9;
    },

    // 是否展示普通抽奖抽奖文案
    isShowOrdinaryDrawText() {
      return !this.pointDrawFlag && this.drawWheelType == BWC.DrawWheelType.ordinaryDraw;
    },

    // 是否展示整点购抽奖文案
    isShowShopOnHourDrawText() {
      return !this.pointDrawFlag && this.drawWheelType == BWC.DrawWheelType.purchaseOnHourDraw;
    },

    // 是否展示定时抽奖文案
    isShowTimedDrawText() {
      return !this.pointDrawFlag && this.drawWheelType == BWC.DrawWheelType.timedDraw;
    },
    // 是否为积分抽奖
    isPointDraw() {
      return this.drawType === BWC.DrawType.PointDraw;
    },
    // 积分抽奖文案
    pointDrawText() {
      if (this.drawStatus === BWC.status.exceedDailyTimes || this.drawStatus === BWC.status.exceedTotalTimes) {
        return this.pageDisplayContent;
      } else {
        return `每次抽奖扣除${this.drawPointConsumption + this.poinsOrDiamonds}`;
      }
    },
    // 活动是否正在进行中
    isRunning() {
      return this.activityStatus === BWC.ActivityStatus.running;
    },
    // 抽奖指针显示的文案
    pointerText() {
      switch (this.activityStatus) {
        case BWC.ActivityStatus.notStarted:
          return '活动未开始';
        case BWC.ActivityStatus.paused:
          return '活动已暂停';
        case BWC.ActivityStatus.finished:
          return '活动已结束';
        default:
          return '';
      }
    },
  },
  methods: {
    goWinnerList() {
      this.$emit('goWinnerList');
    },
    goHiHonorMiniProgram(e) {
      this.$emit('goHiHonorMiniProgram', e);
    },
    pointer() {
      this.$emit('pointer');
    },
    noChanceFirst() {
      if (this.tipsMessageCode === 1501 || this.tipsMessageCode === 1502) {
        this.$emit('updateIsShowIdentityDialog');
      } else {
        this.noChance(this.tipsMessage);
      }
    },
    viewRecord(item) {
      this.$emit('viewRecord', item);
    },
    openGuide() {
      this.$emit('openGuide');
    },
    goLottery() {
      this.$emit('goLottery');
    },
    nextStep(link, type) {
      this.$emit('nextStep', link, type);
    },
  },
};
</script>
<style scoped lang='scss'>
.blind-box {
  width: 100vw;
  .lottery-wrapper {
    height: 173.333vw !important;
    width: 100%;
    background-size: 100% 100%;
    background-repeat: no-repeat;
  }
  /deep/ .other-btn {
    padding: 25px 20px 0 20px;
  }
  /deep/ .blindBox-info {
    margin: 10px auto 10px !important;
  }
}
.banner .turnplate .pointer,
.member-login {
  position: absolute;
  width: 32%;
  height: 39.07%;
  left: 34.3%;
  top: 26%;
  font-size: 14px;
  color: #fff;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
}
.banner .turnplate {
  margin-top: 20px;
  overflow: hidden;
  display: block;
  width: 100%;
  position: relative;
}
.banner {
  display: block;
  width: 97%;
  max-width: 360px;
  margin-left: auto;
  margin-right: auto;
}
.banner .turnplate canvas.item {
  width: 100%;
}
.banner .turnplate .pointer img,
.member-login img {
  width: 100%;
}
.awardRotateDisc {
  position: relative;
  /deep/ .member-tips-login {
    margin: 10px auto;
  }
}
.blindBox-main {
  width: 100%;
  max-width: 480px;
  position: relative;

  .blindBox-box,
  .blindBox-mask {
    width: 49%;
    height: 35%;
    position: absolute;
    top: 24%;
    left: 50%;
    transform: translate(-50%, 0);
    display: flex;
    flex-wrap: wrap;
    align-items: center;

    img {
      width: 23%;
      height: initial;
      margin-right: 15.5%;

      &:nth-child(3n) {
        margin: 0;
      }
    }

    .blindBox-anima {
      animation: blindBoxAnimation 0.6s linear;
    }
  }
  .blindBox-box-nine {
    height: 45% !important;
    top: 21% !important;
  }
}
.blindBox-chance {
  font-family: HYQiHei-FZS;
  font-size: 16px;
  color: #ffffff;
  text-align: center;
  font-weight: 400;
  padding: 10px 0;
}
.guideLotteryUrl {
  width: 40%;
  height: 20%;
  position: absolute;
  top: 6%;
  left: 50%;
  transform: translate(-50%, 0);
}
.member-login-btn {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  overflow: hidden;
}
.before-award-mask-nine {
  height: 76% !important;
  top: 52% !important;
}
.before-award-mask {
  width: 78%;
  height: 73%;
  top: 51%;
  left: 50%;
  transform: translate(-50%, -50%);
  border-radius: 55px;
  position: absolute;
  z-index: 999;
  background-color: rgba(0, 0, 0, 0.4);
  .award-mask-center {
    width: 75%;
    font-size: 28px;
    color: #fff;
    font-weight: bold;
    text-align: center;
    position: absolute;
    margin: 10px;
    top: 45%;
    left: 47%;
    transform: translate(-50%, -50%);

    .font-24 {
      margin-top: 10px;
      margin-bottom: 20px;
      font-size: 24px;
    }
    .font-20 {
      margin-top: 5px;
      margin-bottom: 5px;
      font-size: 20px;
    }
    .lottery-btn {
      width: 124px;
      height: 38px;
      background-image: linear-gradient(90deg, #faf2df 0%, #f1e1c2 100%);
      border-radius: 36px;
      position: relative;
      span {
        position: absolute;
        left: 50%; /* 定位父级的50% */
        top: 50%;
        transform: translate(-50%, -50%); /*自己的50% */
        font-family: HYQiHei-GEW;
        font-size: 18px;
        color: #b27d13;
        letter-spacing: 0;
        line-height: 54px;
        font-weight: 600;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/page/vibrantRubikCube/runtime/lucky-draw/lucky-draw-page/blind-box/blind-box.vue